module.exports = __webpack_public_path__ + "img/1.3d429f31.jpg";